exports.RxDragLocales = {
  Button: "按钮",
  Avatar: "头像",
  Badge: "徽标数",
  IconView: "图标",
  ImageView: "图片",
  LoopPanel: "循环面板",
  Statistic: "统计数值",
  Tag: "标签",
  predefined: "预定义",
  customized: "自定义",
  InputField: "输入框字段",
  Form: "表单",
  FormItem: "表单条目",
  AutoComplete: "自动完成",
  Cascader: "级联选择",
  Checkbox: "复选框",
  DatePicker: "日期选择框",
  DateRangePicker: "日期范围",
  Input: "输入框",
  TextArea: "多行输入框",
  InputNumber: "数字输入框",
  Mentions: "提及",
  Radio: "单选框",
  Rate: "评分",
  Select: "下拉框",
  Slider: "滑动输入",
  Switch: "开关",
  TimePicker: "时间选择框",
  Transfer: "穿梭框",
  TreeSelect: "树选择",
  Box: "盒子",
  Breadcrumb: "面包屑导航",
  Card: "卡片",
  Col: "列",
  Divider: "分割线",
  HCFLayout: "上中下布局",
  Hero: "大块屏",
  Logo: "Logo",
  Menu: "菜单",
  Paper: "纸张",
  Row: "行",
  Space: "间距",
  TwoColumnLayout: "两列布局",
  Dialog: "对话框",
  Drawer: "抽屉",
  Dropdown: "下拉菜单",
  Popconfirm: "气泡确认框",
  Popover: "气泡卡片",
  Tooltip: "文字提示",
  Text: "文本"
};
